module.exports = __webpack_public_path__ + "static/img/logo2.3eca3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/logo2.png
// module id = n9aG
// module chunks = 0